class WPTab extends HTMLElement {
  constructor(self) {
    self = super(self);
    this.setAttribute('role', 'tab');
    this.setAttribute('tabindex', -1);
    return self;
  }

  static get is() {
    return 'wp-tab';
  }

  static get observedAttributes() {
    return ['selected'];
  }

  get selected() {
    return this.hasAttribute('selected');
  }

  set selected(value) {
    if (Boolean(value)) {
      this.setAttribute('selected', '');
    } else {
      this.removeAttribute('selected');
    }
  }

  connectedCallback() {
    this.addEventListener('click', this._handleClick, false);
    this.addEventListener('focus', this._handleClick, false);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'selected':
        this._selectedChanged();
    }
  }

  _handleClick() {
    this.selected = true;
  }

  _selectedChanged() {
    if (this.selected) {
      this.setAttribute('aria-selected', 'true');
      this.tabIndex = 0;
      this.$emit('tabchanged', this);
    } else {
      this.setAttribute('aria-selected', 'false');
      this.tabIndex = -1;
    }
  }
}

customElements.define(WPTab.is, WPTab);
